var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMapPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.139,
    height: 32.613,
    viewBox: "0 0 26.139 32.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5775",
    "data-name": "Group 5775",
    transform: "translate(13981.14 -5739.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9454",
    "data-name": "Path 9454",
    d: "M40.521,21.53a12.984,12.984,0,0,0,.228-2.418,12.819,12.819,0,0,0-25.58-1.253,13.128,13.128,0,0,0,.169,3.674,3.264,3.264,0,0,0,.088.4,12.86,12.86,0,0,0,.856,2.535c1.389,3.274,4.446,8.311,11.144,13.727a.786.786,0,0,0,.5.176.83.83,0,0,0,.5-.176c6.7-5.412,9.755-10.446,11.144-13.723a12.97,12.97,0,0,0,.845-2.51,3.414,3.414,0,0,0,.1-.437Zm-1.168-.209v.033a2.509,2.509,0,0,1-.07.327,11.71,11.71,0,0,1-.786,2.307h0c-1.326,3.123-4.222,7.9-10.567,13.1-6.345-5.2-9.241-9.972-10.552-13.077h0a12.1,12.1,0,0,1-.786-2.315c-.044-.2-.066-.309-.07-.327a.05.05,0,0,1,0-.026A12,12,0,0,1,16.363,18,11.633,11.633,0,0,1,39.57,19.135a11.138,11.138,0,0,1-.217,2.185Z",
    transform: "translate(-13996 5733.734)",
    fill: "#0087c3",
    stroke: "#0087c3",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9455",
    "data-name": "Path 9455",
    d: "M38.746,22.75a6.536,6.536,0,1,0,6.536,6.536,6.536,6.536,0,0,0-6.536-6.536Zm0,11.971a5.434,5.434,0,1,1,5.434-5.434A5.434,5.434,0,0,1,38.746,34.721Z",
    transform: "translate(-14006.816 5723.307)",
    fill: "#0087c3",
    stroke: "#0087c3",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapPin);
export default __webpack_public_path__ + "static/media/icon-map-pin.a24456cd5c1093c3bc31bdbfc4e41188.svg";
export { ForwardRef as ReactComponent };